import { Form, Input, message } from 'antd';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { AiOutlineEnter } from 'react-icons/ai';
import FormComponent from 'src/app/components/FormComponent/FormComponent';
import OrderedTags from 'src/app/components/OrderedTagsComponent/OrderedTags';
import { IFormProps } from 'src/app/forms/form.config';
import {
  useCreateTopicMutation,
  useGetTopicsIdentifiedQuery,
  useUpdateTopicMutation,
} from 'src/app/redux/topics/topicIdentifiedSlice';

const TopicIdentifiedForm: React.FC<IFormProps> = ({ form, recordId, destroyModal }) => {
  const [aliases, setAliases] = useState<string[]>([]);

  const { data: editData } = useGetTopicsIdentifiedQuery(undefined, {
    skip: !recordId,
    selectFromResult: ({ data }) => ({
      data: data?.rows.find((row) => row.id === recordId),
    }),
    refetchOnMountOrArgChange: true,
  });

  const [createTopic] = useCreateTopicMutation();
  const [updateTopic] = useUpdateTopicMutation();

  const onFinish = (values: any) => {
    if (!recordId) {
      createTopic(values)
        .unwrap()
        .then(() => {
          message.success(t('success.added'));
          form.resetFields();
          if (destroyModal) destroyModal();
        })
        .catch(() => message.success(t('errors.unknownError')));
    } else {
      updateTopic({
        id: recordId,
        ...values,
      })
        .unwrap()
        .then(() => {
          message.success(t('success.edited'));
          form.resetFields();
          if (destroyModal) destroyModal();
        })
        .catch(() => message.success(t('errors.unknownError')));
    }
  };

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        name: editData.name,
      });
      setAliases(editData.aliases.map((alias) => alias.value));
    }
  }, [editData]);

  useEffect(() => {
    form.setFieldValue('aliases', aliases);
  }, [aliases]);

  return (
    <FormComponent options={{ form, onFinish }}>
      <Form.Item name="name" label={t('forms.topicIdentifiedForm.name')} rules={[{ required: true }]}>
        <Input variant="borderless" />
      </Form.Item>
      <Form.Item label={t('forms.topicIdentifiedForm.aliases')} name="aliases">
        <div style={{ display: 'flex', width: '100%' }}>
          <Input variant="borderless" onPressEnter={(e: any) => setAliases((prev) => [...prev, e.target.value])} />
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={() => {
              const alias = form.getFieldValue('aliases');
              if (!Array.isArray(alias)) setAliases((prev) => [...prev, alias]);
            }}
          >
            <span style={{ color: 'white' }}>{t('global.enter')}</span>
            <AiOutlineEnter size={26} color="white" />
          </div>
        </div>
      </Form.Item>

      <OrderedTags tags={aliases} setTags={setAliases} />
    </FormComponent>
  );
};

export default TopicIdentifiedForm;
